import { Card, CardContent } from "@mui/material";
import { forwardRef, ReactNode, Ref, SyntheticEvent } from "react";

const noteCardStyles = {
  root: {
    maxWidth: 640,
    "&:not(:last-child)": {
      marginBottom: 1,
    },
    cursor: "pointer",
    "& > .MuiCardContent-root": {
      pb: 1,
      "&:last-child": {
        pb: 1,
      },
    },
  },
  content: {
    padding: 1,
  },
  fullWidth: {
    width: "100%",
    maxWidth: "none",
  },
};

type NoteCardPropsType = {
  onClick?: (e: SyntheticEvent) => void;
  children: ReactNode | ReactNode[];
  isBookingDetails?: boolean;
};

function NoteCard(props: NoteCardPropsType, ref: Ref<HTMLDivElement>) {
  const { onClick, children, isBookingDetails } = props;

  return (
    <Card
      ref={ref}
      variant="outlined"
      onClick={onClick}
      sx={{ ...noteCardStyles.root, ...(isBookingDetails && noteCardStyles.fullWidth) }}
    >
      <CardContent sx={noteCardStyles.content}>{children}</CardContent>
    </Card>
  );
}

export default forwardRef(NoteCard);
